import React from 'react';
import classes from "../styles/pages/portfolioPage.module.scss";
import image1 from '../images/portfolio/startPhotos/1.webp';
import image2 from '../images/portfolio/startPhotos/2.webp';
import image3 from '../images/portfolio/startPhotos/3.webp';
import image4 from '../images/portfolio/startPhotos/4.webp';
import image5 from '../images/portfolio/startPhotos/5.webp';
import image6 from '../images/portfolio/startPhotos/6.webp';
import image7 from '../images/portfolio/startPhotos/7.webp';
import {Carousel} from "react-bootstrap";

function HomeSlider() {

    return(
        <Carousel variant="dark">
            <Carousel.Item interval={20000}>
                <img src={image1} className={classes.carouselImages}/>
            </Carousel.Item>
            <Carousel.Item interval={20000}>
                <img src={image2} className={classes.carouselImages} loading="lazy"/>
            </Carousel.Item>
            <Carousel.Item interval={20000}>
                <img src={image3} className={classes.carouselImages} loading="lazy"/>
            </Carousel.Item>
            <Carousel.Item interval={20000}>
                <img src={image4} className={classes.carouselImagesVertical} loading="lazy"/>
            </Carousel.Item>
            <Carousel.Item interval={10000}>
                <img src={image5} className={classes.carouselImages} loading="lazy"/>
            </Carousel.Item>
            <Carousel.Item interval={20000}>
                <img src={image6} className={classes.carouselImages} loading="lazy"/>
            </Carousel.Item>
            <Carousel.Item interval={20000}>
                <img src={image7} className={classes.carouselImages} loading="lazy"/>
            </Carousel.Item>
        </Carousel>
    );
}

export default HomeSlider;